import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from 'react-query';

import { publicUrlsServices } from 'services/cv';
import { getErrorText } from 'utils/geterrortext';

import slugify from 'slugify';

import TextInput from '@core/components/textinput/TextInput';

import classes from './EditProfileUrl.module.scss';
import ActionButton from '@core/components/actionbutton/ActionButton';


const EditProfileUrl = ({ data, onCloseHandler, toast, refetch }) => {
    const {
        register,
        handleSubmit,
        setError,
        formState: { errors }
    } = useForm({
        reValidateMode: 'onChange',
        mode: 'onChange',
        defaultValues: {
            url: data?.public_url.url || '',
        }
    });
    const { mutate } = useMutation(['public-urls'], publicUrlsServices.PUT, {
        onSuccess: () => {
            toast(
                'Your public profile URL has been updated.',
                'success'
            );
            refetch();
            onCloseHandler();
        },
        onError: (err) => {
            toast(
                err.response.data.data.url?.[0] || err.response.data.data,
                'alert'
            );
            setError('url', { type: 'custom', message: (err.response.data.data.url?.[0]) });

        }
    });
    const submitForm = (payload) => {
        mutate(payload);
    };
    return (
        <div className={classes['edit-wrapper']}>
            <form onSubmit={handleSubmit(submitForm)} className={classes['subscribe-form']}>
                <h3>Edit your custom URL</h3>
                <p>Create a personalized URL for your profile.</p>
                <div className='d-flex align-items-start flex-sm-row flex-column'>
                    <label className={classes['url']}>https://pharmuni/public-profile/</label>
                    <TextInput
                        validation={{
                            required: { value: true, message: 'This field is required' },
                            minLength: { value: 3, message: 'This field must be 3-100 letters' },
                            maxLength: { value: 100, message: 'This field must be 3-100 letters' },
                            pattern: {
                                value: /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
                                message: 'Please enter a correct slug'
                            }
                        }}
                        input={{
                            name: 'url',
                            id: 'url',
                        }}
                        errors={errors}
                        register={register}
                    />
                </div>
                <p className={classes['note']}>
                    Note: Your custom URL must contain 3-100 letters or numbers.
                    Please do not use spaces, symbols, or special characters.
                </p>
                <div className={classes['action-wrapper']}>
                    <ActionButton kind='blank' onClick={() => onCloseHandler()}>
                        Cancel
                    </ActionButton>
                    <ActionButton type='submit'>
                        Save
                    </ActionButton>
                </div>
            </form>
        </div>
    );
};

export default EditProfileUrl;